module.exports = __webpack_public_path__ + "img/mockup_biz@2x.6c0180e1.png";